import React from "react";

// Model
import { gallery } from "../../model/data";

// Hooks
import useDevice from "../../hooks/useDevice";

// Components
import {
    ImageList,
    ImageListItem,
    Divider,
    Typography,
    Paper,
} from "@mui/material";

const Gallery = (props) => {
    const { device } = useDevice();

    return (
        <div {...props} className={`vjc_main-gallery ${device}`}>
            <Divider sx={{ marginBottom: "50px" }}>
                <Typography variant="h1" sx={{ fontSize: "26px" }}>
                    Gallery
                </Typography>
            </Divider>

            <ImageList variant="masonry" cols={device === "mobile" ? 1 : 3} gap={10}>
                {(device === "mobile" ? [...gallery].slice(0, 3) : [...gallery]).map(
                    (image, index) => (
                        <Paper elevation={2} key={index}>
                            <ImageListItem key={image}>
                                <img
                                    srcSet={`${image}?w=248&fit=crop&auto=format&dpr=2 2x`}
                                    src={`${image}?w=248&fit=crop&auto=format`}
                                    alt={image}
                                    loading="lazy"
                                />
                            </ImageListItem>
                        </Paper>
                    )
                )}
            </ImageList>
        </div>
    );
};

export default Gallery;
